<script>
export default {
  name: 'ListadoItem',
  props: {
    nombreCampo: {
      type: String,
      required: true,
    },
    valorCampo: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>

<template>
  <v-list class="py-1" dense>
    <v-list-item dense three-line>
      <v-list-item-content class="pa-0">
        <v-list-item-title class="caption">{{ nombreCampo }}</v-list-item-title>
        <v-list-item-subtitle class="caption">{{ valorCampo }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<style scoped>
::v-deep .v-list--dense .v-list-item.v-list-item--three-line,
::v-deep .v-list-item--dense.v-list-item--three-line {
  min-height: 40px !important;
}
</style>
